import { Injectable, inject } from '@angular/core';

import { TranslateService } from '@ngx-translate/core';

import { FloorTypeApiModel } from '../../api';

@Injectable({ providedIn: 'root' })
export class FloorTypeLabelService {
  private readonly translate = inject(TranslateService);

  public labels(): string[] {
    return Object.values(FloorTypeApiModel).map((type) => this.label(type));
  }

  public label(value: string): string {
    const type = this.toType(value);

    if (type === null) {
      return value;
    }

    return this.translatedLabel(type) ?? type;
  }

  public toType(value: string): FloorTypeApiModel | null {
    const trimmed = (value || '').trim();

    if (!trimmed) {
      return null;
    }

    const knownTypes = Object.values(FloorTypeApiModel);
    const exactType = knownTypes.find((type) => type === trimmed);

    if (exactType) {
      return exactType;
    }

    const labelMatch = knownTypes.find(
      (type) => this.translatedLabel(type) === trimmed,
    );

    if (labelMatch) {
      return labelMatch;
    }

    const normalized = FloorTypeLabelService.normalize(trimmed);

    return (
      knownTypes.find(
        (type) => FloorTypeLabelService.normalize(type) === normalized,
      ) ?? null
    );
  }

  public isKnown(value: string): boolean {
    return this.toType(value) !== null;
  }

  private translatedLabel(type: FloorTypeApiModel): string | null {
    const key = `FLOOR_TYPES.${type}`;
    const translated = this.translate.instant(key) as string;

    return translated === key ? null : translated;
  }

  private static normalize(value: string): string {
    return value.toLowerCase().replace(/[^a-z0-9]/g, '');
  }
}
